module.exports = __webpack_public_path__ + "static/img/1.e00516b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/internationalBrand/kmR410A/1.jpg
// module id = /cxj
// module chunks = 1